import { render, staticRenderFns } from "./CoreValues.vue?vue&type=template&id=5f98b0e8"
import script from "./CoreValues.vue?vue&type=script&lang=js"
export * from "./CoreValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports